import { useEffect, useState } from "react";
import { useConf } from "../../context/account/paramsAccount";
import { FormattedMessage } from "react-intl";
import { ListePrestaPersonel } from "../../interface/retourPrestation/retourPrestation";
import { convertDecimalToTime, handleInputChangePrestaMateriel, handleTimeChangePresta } from "../../functions/inputFunctions/inputFunctions";
import { useError } from "../../context/erreur/erreurContext";
import TimeInput from "../../components/kendo/timeInput";
import { Checkbox } from "@progress/kendo-react-inputs";
interface DataSendPerso {
    rpl_heure_reelle_depart_site: string | null;
    v_heure_prevue_depart_site: string,
    rpl_heure_a_facturer: string;
    rpl_heure_consommee_en_plus: number;
    e_uret_id: null,
    e_rpl_id: number,
    rpl_facturer_heure_suppl: boolean

}


const RenderPersonnel = ({ sub, details, setDetails, parentId, isValid }: { sub: ListePrestaPersonel, details: any, setDetails: any, parentId: any, isValid: boolean }) => {
    const { conf, setConf }: any = useConf()
    const { showError } = useError();
    const [dataSend, setDataSend] = useState<DataSendPerso>({
        rpl_heure_reelle_depart_site: sub?.rpl_heure_reelle_depart_site !== null ? sub?.rpl_heure_reelle_depart_site?.substring(0, 5) : sub?.v_heure_prevue_depart_site.substring(0, 5),
        rpl_heure_consommee_en_plus: Number(sub?.rpl_heure_consommee_en_plus),
        rpl_heure_a_facturer: sub?.rpl_heure_a_facturer,
        v_heure_prevue_depart_site: sub?.v_heure_prevue_depart_site !== null ? sub?.v_heure_prevue_depart_site.substring(0, 5) : "",
        e_uret_id: null,
        e_rpl_id: parseInt(sub?.rpl_id),
        rpl_facturer_heure_suppl: true
    });
    function mergeDataSend(existing: any[] = [], newItem: any) {
        // Cherche si un élément avec le même e_rpl_id existe déjà
        const index = existing.findIndex(item => item.e_rpl_id === newItem.e_rpl_id);

        if (index !== -1) {
            // Remplace l'élément existant
            const updated = [...existing];
            updated[index] = { ...existing[index], ...newItem };
            return updated;
        }

        // Sinon, ajoute le nouvel élément
        return [...existing, newItem];
    }

    useEffect(() => {
        setDataSend({
            rpl_heure_reelle_depart_site: sub?.rpl_heure_reelle_depart_site !== null ? sub?.rpl_heure_reelle_depart_site?.substring(0, 5) : sub?.v_heure_prevue_depart_site.substring(0, 5),
            rpl_heure_consommee_en_plus: Number(sub?.rpl_heure_consommee_en_plus),
            rpl_heure_a_facturer: sub?.rpl_heure_a_facturer,
            v_heure_prevue_depart_site: sub?.v_heure_prevue_depart_site !== null ? sub?.v_heure_prevue_depart_site.substring(0, 5) : "",
            e_uret_id: null,
            e_rpl_id: parseInt(sub.rpl_id),
            rpl_facturer_heure_suppl: sub?.rpl_facturer_heure_suppl,
        })

    }, [sub?.rpl_heure_reelle_depart_site, sub?.rpl_heure_consommee_en_plus, sub?.v_heure_prevue_depart_site, sub?.rpl_facturer_heure_suppl])
    useEffect(() => {
        setDetails((prevDetails: any) => {
            const updatePhase = (phase: any): any => {
                if (!phase || phase.rpl_id === null || phase?.rpl_id === '') return phase;

                // Si c'est un E, on descend dans les enfants
                if (phase?.rpl_type === "E" && Array.isArray(phase?.sous_categorie)) {
                    const hasP = phase?.sous_categorie.some((child: any) => child?.rpl_type === "P");
                    if (hasP) {
                        return {
                            ...phase,
                            sous_categorie: phase?.sous_categorie.map((child: any) => {
                                if (child?.rpl_type === "P") {
                                    // Vérifie si ce P contient un descendant A avec l'id du dataSend
                                    const containsA = child?.sous_categorie?.some(
                                        (sub: any) =>
                                            sub.rpl_type === "A" &&
                                            parseInt(sub.rpl_id) === dataSend.e_rpl_id
                                    ) || child?.sous_categorie?.some(
                                        (sub: any) =>
                                            sub.rpl_type === "C" &&
                                            sub?.sous_categorie?.some(
                                                (a: any) =>
                                                    a.rpl_type === "A" &&
                                                    parseInt(a.rpl_id) === dataSend.e_rpl_id
                                            )
                                    );



                                    if (containsA) {

                                        return {
                                            ...child,
                                            dataSend: mergeDataSend(child.dataSend, dataSend),
                                            sous_categorie: Array.isArray(child.sous_categorie)
                                                ? child.sous_categorie.map(updatePhase)
                                                : child.sous_categorie,
                                        };
                                    }
                                    return child; // pas de match → on ne touche pas
                                } else {
                                    return updatePhase(child);
                                }
                            }),
                        };
                    } else {

                        // Pas de P, on merge directement dans la phase E
                        return {
                            ...phase,
                            dataSend: mergeDataSend(phase.dataSend, dataSend),
                        };
                    }
                }
                else {
                    // details[0] est ton objet central
                    const mainDetail = details[0];

                    // On récupère ou initialise dataSend[0]
                    const currentDataSend = Array.isArray(mainDetail.dataSend) && mainDetail.dataSend.length > 0
                        ? mainDetail.dataSend[0]
                        : {};

                    // Pour chaque phase dans details (sauf index 0)
                    details.slice(1).forEach((phase: any) => {
                        if (phase.rpl_type === "A" && phase.v_personnel) {
                            const e_rpl_id = parseInt(phase.rpl_id);

                            // Cherche si ce matériel existe déjà dans dataSend
                            const index = mainDetail.dataSend.findIndex((ds: any) => ds.e_rpl_id === e_rpl_id);

                            const updatedData = {
                                e_rpl_id,
                                v_heure_prevue_depart_site: phase.v_heure_prevue_depart_site || 0,
                                rpl_heure_reelle_depart_site: phase.rpl_heure_reelle_depart_site || 0,
                                rpl_heure_consommee_en_plus: phase.rpl_heure_consommee_en_plus || 0,
                                rpl_heure_a_facturer: phase.rpl_heure_a_facturer || null,
                                rpl_facturer_heure_suppl: phase.rpl_facturer_heure_suppl || true
                            };

                            if (index >= 0) {
                                // Met à jour l'objet existant
                                mainDetail.dataSend[index] = updatedData;
                            } else {
                                // Sinon, ajoute-le
                                mainDetail.dataSend.push(updatedData);
                            }
                        }
                    });


                }
                return {
                    ...phase,
                    sous_categorie: Array.isArray(phase?.sous_categorie)
                        ? phase.sous_categorie.map(updatePhase)
                        : phase.sous_categorie,
                };
            };

            return prevDetails?.map(updatePhase);
        });

        // Maintenant, teste le type
        // if (phase.rpl_type === "P") {
        //     return {
        //         ...phase,
        //         dataSend: mergeDataSend(phase.dataSend, dataSend),
        //         sous_categorie: updatedChildren, // enfants déjà mis à jour
        //     };
        // }



        const savedData = localStorage.getItem(`prestaHl_${conf.user.user_code}`);
        let prestas = savedData ? JSON.parse(savedData) : [];

        const updatePrestaRecursive = (presta: any): any => {
            if (!presta || presta.rpl_id === null || presta?.rpl_id === '') return presta;

            // Si c'est un E, on descend dans les enfants
            if (presta?.rpl_type === "E" && Array.isArray(presta?.sous_categorie)) {
                const hasP = presta?.sous_categorie.some((child: any) => child?.rpl_type === "P");
                if (hasP) {
                    return {
                        ...presta,
                        sous_categorie: presta?.sous_categorie.map((child: any) => {
                            if (child?.rpl_type === "P") {
                                // Vérifie si ce P contient un descendant A avec l'id du dataSend
                                const containsA = child?.sous_categorie?.some(
                                    (sub: any) =>
                                        sub.rpl_type === "A" &&
                                        parseInt(sub.rpl_id) === dataSend.e_rpl_id
                                ) || child?.sous_categorie?.some(
                                    (sub: any) =>
                                        sub.rpl_type === "C" &&
                                        sub?.sous_categorie?.some(
                                            (a: any) =>
                                                a.rpl_type === "A" &&
                                                parseInt(a.rpl_id) === dataSend.e_rpl_id
                                        )
                                );


                                if (containsA) {
                                    return {
                                        ...child,
                                        dataSend: mergeDataSend(child.dataSend, dataSend),
                                        sous_categorie: Array.isArray(child.sous_categorie)
                                            ? child.sous_categorie.map(updatePrestaRecursive)
                                            : child.sous_categorie,
                                    };
                                }
                                return child; // pas de match → on ne touche pas
                            } else {
                                return updatePrestaRecursive(child);
                            }
                        }),
                    };
                } else {
                    // Pas de P, on merge directement dans la phase E
                    return {
                        ...presta,
                        dataSend: mergeDataSend(presta.dataSend, dataSend),
                    };
                }
            }
            else {
                // details[0] est ton objet central
                const mainDetail = details[0];

                // On récupère ou initialise dataSend[0]
                const currentDataSend = Array.isArray(mainDetail.dataSend) && mainDetail.dataSend.length > 0
                    ? mainDetail.dataSend[0]
                    : {};

                // Pour chaque phase dans details (sauf index 0)
                details.slice(1).forEach((phase: any) => {
                    if (phase.rpl_type === "A" && phase.v_personnel) {
                        const e_rpl_id = parseInt(phase.rpl_id);

                        // Cherche si ce matériel existe déjà dans dataSend
                        const index = mainDetail.dataSend.findIndex((ds: any) => ds.e_rpl_id === e_rpl_id);

                        const updatedData = {
                            e_rpl_id,
                            v_heure_prevue_depart_site: phase.v_heure_prevue_depart_site || 0,
                            rpl_heure_reelle_depart_site: phase.rpl_heure_reelle_depart_site || 0,
                            rpl_heure_consommee_en_plus: phase.rpl_heure_consommee_en_plus || 0,
                            rpl_heure_a_facturer: phase.rpl_heure_a_facturer || null,
                            rpl_facturer_heure_suppl: phase.rpl_facturer_heure_suppl || true
                        };

                        if (index >= 0) {
                            // Met à jour l'objet existant
                            mainDetail.dataSend[index] = updatedData;
                        } else {
                            // Sinon, ajoute-le
                            mainDetail.dataSend.push(updatedData);
                        }
                    }
                });


            }
            return {
                ...presta,
                sous_categorie: Array.isArray(presta?.sous_categorie)
                    ? presta.sous_categorie.map(updatePrestaRecursive)
                    : presta.sous_categorie,
            };
        };


        const updatedPrestas = prestas.map(updatePrestaRecursive);

        localStorage.setItem(
            `prestaHl_${conf.user.user_code}`,
            JSON.stringify(updatedPrestas)
        );

    }, [dataSend, parentId, conf.user.user_code]);

    return (
        <>
            <TimeInput
                name={<FormattedMessage id="heurePrevue" defaultMessage="Heure de départ prévue" />}
                onChange={(value: string) => { handleTimeChangePresta("v_heure_prevue_depart_site", value, setDetails, sub.rpl_id, showError) }}
                value={sub?.v_heure_prevue_depart_site !== null ? sub?.v_heure_prevue_depart_site.substring(0, 5) : ""}
                readOnly={sub?.v_heure_prevue_depart_site === null ? false : true}
            />
            <TimeInput
                name={<FormattedMessage id="heureReelle" defaultMessage="Heure réelle de départ" />}
                onChange={(value: string) => { handleTimeChangePresta("rpl_heure_reelle_depart_site", value, setDetails, sub.rpl_id, showError) }}
                value={sub?.rpl_heure_reelle_depart_site !== null ? sub?.rpl_heure_reelle_depart_site : sub?.v_heure_prevue_depart_site.substring(0, 5)}
                readOnly={isValid}
            />
            <TimeInput
                name={<FormattedMessage id="heureConsommee" defaultMessage="Heure supplémentaire" />}
                onChange={(value: string) => { handleTimeChangePresta("rpl_heure_consommee_en_plus", value, setDetails, sub.rpl_id, showError) }}
                value={convertDecimalToTime(Number(sub?.rpl_heure_consommee_en_plus))}
                readOnly={true}
            />
            <Checkbox
                disabled={isValid}
                label="Facturer l'heure supplémentaire"
                value={sub?.rpl_facturer_heure_suppl === null ? true : sub?.rpl_facturer_heure_suppl}
                onChange={() => {
                    handleInputChangePrestaMateriel(sub.rpl_id, setDetails, 'rpl_facturer_heure_suppl', sub?.rpl_facturer_heure_suppl === undefined ? false : sub?.rpl_facturer_heure_suppl)
                }}
            />
            {/* <TimeInput
                name="Heure départ à facturer"
                value={dataSend.rpl_heure_a_facturer}
                onChange={(value) => handleTimeChange("rpl_heure_a_facturer", value)}
            /> */}


            {/* <svg className="iconValid" onClick={() => { ValidLignePrestaMaterielCasse(dataSend, conf, setConf, showError) }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z" /></svg > */}
        </>
    );
};
export default RenderPersonnel